"use client";
import { Fragment } from "react";
import { ControlsYearType } from "@/utils/types";
import { useAppStore } from "@/store/app";
import { useDataStore } from "@/store/data";
import { cn, formatValue, getValue } from "@/utils/helpers";
import { getAgeGroups, getControlStats, getLang, getYearsOfStat } from "@/utils/selectors";
import Tooltip from "@/components/common/Tooltip";
import { SvgIconInfo } from "@/components/common/Svg";
import Skeleton from "@/components/common/Skeleton";
import ProfileTempOutPctl from "./ProfileTempOutPctl";
import styles from "../Profile.module.css";

export default function ProfileTempOut() {
	const controls = useAppStore(store => store.controls);
	const selectedLocation = useAppStore(store => store.selectedLocation);
	const dataLoading = useDataStore(store => store.dataLoading);

	return (
		<div
			className={styles.ProfileTempOut}
		>
			{getAgeGroups().map((age: string, index: number) =>
				<div
					key={index}
					className={styles.ProfileTempOutGroup}
				>
					<h4
						className={cn(
							styles.ProfileGroupTitle,
							styles.ProfileTempGroupTitle
						)}
					>
						<span>{getLang("stat", "out")} for {getLang("age", age)}</span>
					</h4>
					<div className={styles.ProfileTempOutStats}>
						{getControlStats(controls.view, "out", age)
							.filter((stat: string) =>
								// Filters to only stats in age group
								stat.includes(age)
								// Filters out CA-specific stats if not in CA
								// && !(stat.includes("edv") && stateFips !== "06")
							)
							.map((stat: string, index: number) =>
							<div
								key={index}
								className={cn(
									styles.ProfileStat,
									styles.ProfileTempOutStat
								)}
							>
								<hgroup
									className={styles.ProfileStatHeading}
								>
									<div>
										<h4
											className={styles.ProfileStatTitle}
										>
											{getLang(controls.view, stat)}
										</h4>
										<Tooltip
											hasIcon={true}
											inner={getLang( controls.view, stat, "tooltip", { geo: getLang("geo", controls.geo)?.toLocaleLowerCase() })}
											footer={getLang("stat", "tooltip", "footer")}
											className={styles.ProfileStatTitleTooltip}
										/>
									</div>
								</hgroup>
								<dl
									className={cn(
										styles.ProfileStatValues,
										styles.ProfileTempStatValues,
										styles.ProfileTempOutStatValues
									)}
								>
									{getYearsOfStat(controls.view, stat).map((year: ControlsYearType, index: number) =>
										<Fragment
											key={index}
										>
											<dt
												className={cn(
													styles.ProfileStatLabel,
													styles.ProfileStatLabelVal
												)}
											>
												{getLang("year", year, "short")}
											</dt>
											<dd
												className={cn(
													styles.ProfileStatValue,
													styles.ProfileStatValueVal
												)}
											>
												<Skeleton
													loading={dataLoading}
												>
													{formatValue(
														getValue(`${controls.view}_${stat}_${year}`, selectedLocation),
														stat
													)}
												</Skeleton>
											</dd>
											<dt
												className={cn(
													styles.ProfileStatLabel,
													styles.ProfileStatLabelPctl,
												)}
											>
												<span>
													{getLang("profile", "pctl", controls.geo)}
												</span>
												<Tooltip
													inner={getLang("profile", "pctl", controls.geo, "tooltip", {
														pctl: getValue(`${controls.view}_${stat}_pctl_${year}`, selectedLocation)
													})}
												>
													<SvgIconInfo />
												</Tooltip>
											</dt>
											<dd
												className={cn(
													styles.ProfileStatValue,
													styles.ProfileStatValuePctl,
												)}
											>
												<Skeleton
													loading={dataLoading}
												>
													<ProfileTempOutPctl
														value={getValue(`${controls.view}_${stat}_pctl_${year}`, selectedLocation)}
													/>
												</Skeleton>
											</dd>
										</Fragment>
									)}
								</dl>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
}